/*
 * This module controls the Virtual Exhibitions lightbox used to display
 * images, videos and iframes in a modal window.
 */

// We use the tosrus lightbox
import $ from 'jquery';
import isArray from 'lodash/lang/isArray';
import each from '../../../../node_modules/lodash/collection/each';
import groupBy from '../../../../node_modules/lodash/collection/groupBy';

import 'tosrus';
import { register as registerIframeMedia } from './tosrus.iframe';
import { register as registerVeYouTubeMedia } from './tosrus.ve-youtube';

/**
 * Elements in this special group are always displayed in their own individual
 * lightbox.
 */
const DEFAULT_GROUP = '__default';
const LIGHTBOX_LINK_CLASS = 've-lightbox';
const LIGHTBOX_GROUP_DATA_ATTR = 'lightbox-group';


/**
 * Insert each tagged link into a lightbox, grouped according to the group attr.
 * Ungrouped links are placed into a single default group to allow content to
 * be paged between with the lightbox open.
 */
export function init() {
    registerMedia();

    let groups = groupBy($(`a.${LIGHTBOX_LINK_CLASS}`),
                        el => $(el).data(LIGHTBOX_GROUP_DATA_ATTR) ||
                                         DEFAULT_GROUP);
    each(groups, createLightbox);
}

function registerMedia() {
    registerIframeMedia();
    registerVeYouTubeMedia();
}

function createLightbox(elements) {
    $(elements).tosrus({
        caption: {
            attributes: ['title']
        },
        pagination: {
            add: isArray(elements) && elements.length
        },
        youtube: {
            imageLink: false
        }
    });
}



/** WEBPACK FOOTER **
 ** ./js/view/components/lightbox/index.js
 **/